export const METRICS_SOURCES = {
  google_classroom: "Google Classroom",
  essaygrader: "EssayGrader",
  canvas: "Canvas",
  schoology: "Schoology",
};

export const METRICS_TIME_FILTERS = [
  {
    value: "all_time",
    labelKey: "metrics.allTime",
    getParams: () => ({ period: "month" }),
  },
  {
    value: "this_year",
    labelKey: "metrics.thisYear",
    getParams: () => {
      const now = new Date();
      return {
        period: "month",
        dateFrom: new Date(now.getFullYear(), 0, 1).getTime(),
        dateTo: Date.now(),
      };
    },
  },
  {
    value: "last_year",
    labelKey: "metrics.lastYear",
    getParams: () => {
      const y = new Date().getFullYear() - 1;
      return {
        period: "month",
        dateFrom: new Date(y, 0, 1).getTime(),
        dateTo: new Date(y, 11, 31, 23, 59, 59, 999).getTime(),
      };
    },
  },
  {
    value: "last_90_days",
    labelKey: "metrics.last90Days",
    getParams: () => {
      const now = Date.now();
      return {
        period: "week",
        dateFrom: now - 90 * 24 * 60 * 60 * 1000,
        dateTo: now,
      };
    },
  },
  {
    value: "last_30_days",
    labelKey: "metrics.last30Days",
    getParams: () => {
      const now = Date.now();
      return {
        period: "day",
        dateFrom: now - 30 * 24 * 60 * 60 * 1000,
        dateTo: now,
      };
    },
  },
];
